import { Routes } from "@angular/router";

export const RN_APPCONFIGURATIONS_CHILD_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'edgetoedgeapps', 
    pathMatch: 'full'
  },
  {
    path: 'edgetoedgeapps',
    loadComponent: () => import('../edge-to-edge-apps/edge-to-edge-apps.component').then((c) => c.EdgeToEdgeAppsComponent)
  },
];